<template>
  <v-container>
    <v-layout justify-centerv-if="overlay">
       <v-dialog v-model="overlay" persistent max-width="600">
         <v-card>
           <v-card-text>
              <v-progress-linear
                indeterminate
                color="blue"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
    </v-layout>
    <v-layout>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-title style="color: #151B42; font-size: 2em" color="secondary">{{ $t('key330') }}</v-card-title>
          <v-form v-model="valid">
            <v-card-text>
              <v-flex sm12>
                <v-text-field
                        class="form-control-text" 
                        label="Indirizzo e-mail"
                    v-model="username" :rules="[v => !!v || 'Questo campo è obbligatorio']" color=""
                         required outline ></v-text-field>
                <!-- <v-text-field v-model="username" label="E-Mail" :rules="[v => !!v || 'E-Mail richiesta']" /> -->
              </v-flex>
              <v-flex sm12>
                <v-text-field outline v-model="password" type="password" label="Password" :rules="[v => !!v || 'Questo campo è obbligatorio']" />
              </v-flex>
              <v-btn large style="margin-left: 0px; box-shadow: none; color: white; " @click="login" :disabled="!valid" color="#4EABDD" >ACCEDI</v-btn>
              <v-btn large style="box-shadow: none; color: white;" color="#A0A4A7" @click="clear">{{ $t('key331') }}</v-btn>
              <div>

              <router-link to="/recuperapassword"  style="color: #4EABDD; font-size: 12; text-decoration: none;">
                Password dimenticata?
              </router-link>
              </div>
              <br><br>
              <div style="color: #151B42; font-size:2em;">
                Registrazione nuovo utente
              </div>
              <v-btn  large color="#4EABDD" @click="Registrazione" style="margin-left: 0px; box-shadow: none; color: white;">{{ $t('key354') }}</v-btn>
              
              <!-- <v-btn @click="RecuperaPassword">{{ $t('key332') }}</v-btn> -->
              

            </v-card-text>
            
            <!-- <v-card-text>
              <v-btn  color="#4EABDD" @click="Registrazione" style="border-radius: 5px; box-shadow: none;">{{ $t('key354') }}</v-btn>
            </v-card-text> -->
            <v-card-text v-if="snackbar">
              <h3 style="font-weight: normal;">Attenzione, i campi compilati non sono corretti.</h3>
              <h3 style="font-weight: normal;"><b>Riprova verificando i dati di accesso in tuo possesso</b> o, se non li ricordi,</h3>
              <h3 style="font-weight: normal;"><b>scrivici a assistenzaweb@arco.it</b> per ottenere <b>l'Email</b> oppure utilizza</h3>
              <h3 style="font-weight: normal;">il tasto <b>Recupera Password</b> per ottenere la <b>Password di accesso.</b></h3>
            </v-card-text>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
export default {
  methods: {
    
    validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }
      },
    clear() {
      this.username = ""
      this.password = ""
    },
    login: function() {
      this.overlay = true;
      const { username, password, appId } = this;

      this.$store.dispatch("login", { username, password, appId }).then(res => {
        if(res.data.loggato){
          if (res.data.mustChangePassword == 0) {
            this.$root.$children[0].$emit("benvenuto");
            this.$router.push({ path: `/benvenuto` });
          } else {
            this.$router.push({ path: `/cambiapassword` });
          }
      }
      else{
        this.overlay = false;
        this.snackbar = true
        if(res.data.displayname === "MULTIPLO")
          this.text ="Hai utilizzato un codice associato a più utenze. Utilizza l'email per effettuare l'accesso.";
        else{
          this.text ="Errore durante il login, riprovare";
        }
        //console.log("ERRORE LOGIN")
      }
      },
      error =>{
        this.overlay = false;
        this.snackbar = true
        this.text = "Errore durante il login, riprovare";
        //console.log(error)
      })},
    RecuperaPassword() {
      this.$router.push({ path: `/recuperapassword` });
    },
    Registrazione(){
      this.$router.push({ path: `/registrazione` });
    }
  },
  data() {
    return {
      username: "",
      password: "",
      appId: 1,
      overlay: false,
      valid: false,
      snackbar: false,
      timeout: 6000,
      text: "",
      x: null,
      y: 'top',
      color: 'red',
      mode: ''
    };
  }
};
</script>